const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  data: [],
  duration: null,
  error: null
};

export const accessKeyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_ACCESS_KEY": {
      return { ...initialState };
    }
    case "FETCH_PRESENTATION_ACCESS_KEY_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_PRESENTATION_ACCESS_KEY_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: action.payload
      };
    }
    case "FETCH_PRESENTATION_ACCESS_KEY_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        data: [],
        error
      };
    }

    case "SET_ACCESS_KEY_DURATION": {
      return {
        ...state,
        duration: action.duration
      };
    }

    case `GENERATE_PRESENTATION_ACCESS_KEY_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `GENERATE_PRESENTATION_ACCESS_KEY_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true,
        data: action.payload.data.data
      };
    }
    case `GENERATE_PRESENTATION_ACCESS_KEY_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case "VERIFY_PRESENTATION_ACCESS_KEY_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "VERIFY_PRESENTATION_ACCESS_KEY_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: action.payload
      };
    }
    case "VERIFY_PRESENTATION_ACCESS_KEY_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
            error = {
              title: error.response.data.errors
                ? error.response.data.errors[0].message
                : "An error has occured",
              code: error.response.data.errors
                ? error.response.data.errors[0].code
                : 500
            };
        }
      }
      return {
        ...state,
        fetching: false,
        data: [],
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/access-key.js